import { connect } from 'react-redux';
import compose from 'recompose/compose';
import DocumentWizardBase from './components/document-wizards/document-wizards-base';
import { getRequestDocuments } from './ducks/selectors';


const mapStateToProps = state => ({
    requestDocuments: getRequestDocuments(state)
});

export default compose(connect(mapStateToProps))(
  DocumentWizardBase
);
